export const userResourceUrl = 'users';
